import type { LucideIcon } from 'lucide-react';
import { Calendar, CirclePlus, FileCheck, Funnel, Repeat, Users } from 'lucide-react';

import type { NewPlansSegment } from 'app/utils/newPlansSegment';

export interface IncludedFeature {
  icon: LucideIcon;
  name: string;
  benefit: string;
}

/** What each group of existing customers gained with the new plans, at no extra cost. */
const INCLUDED_FEATURES: Record<NewPlansSegment, IncludedFeature[]> = {
  'legacy-without-pro': [
    {
      icon: CirclePlus,
      name: 'Pharmacy First',
      benefit: 'Offer NHS Pharmacy First consultations and get paid for each one.',
    },
    {
      icon: Calendar,
      name: 'Clinic',
      benefit: 'Take bookings for your private and NHS services online.',
    },
    {
      icon: FileCheck,
      name: 'EPS integration',
      benefit: 'Track prescriptions automatically, no more chasing the GP.',
    },
    {
      icon: Users,
      name: 'Patient insights',
      benefit: 'Yearly orders, last ordered and scheduled orders for every patient.',
    },
  ],
  'plus-without-pro': [
    {
      icon: Repeat,
      name: 'Digital Managed Repeats',
      benefit: 'Manage repeats for patients who don’t use the app, on autopilot.',
    },
    {
      icon: Funnel,
      name: 'Segmented broadcasts',
      benefit: 'Send messages to the right patients by age, condition or last order.',
    },
  ],
};

export default INCLUDED_FEATURES;
